module.exports = __webpack_public_path__ + "img/plane.5ef05c73.svg";